module.exports = __webpack_public_path__ + "assets/865fd164ec01c0c23a2b4690085a62b5.png";